import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/new';

import { useAppData } from 'src/app/data';
import { RepositoryFilters } from 'src/sections/profile/types';

import * as styles from './filters.styles';
import i18n from './profile-watching-filter.i18n';

type Props = {
  watching: string | undefined;
  onFilterChange: (filters: Partial<RepositoryFilters>) => void;
};

const WatchingFilter = (props: Props): JSX.Element | null => {
  const appData = useAppData();
  const { user } = appData;

  if (!user) {
    return null;
  }

  const { watching, onFilterChange } = props;

  const handleFilterChange = () => {
    onFilterChange({ watching: !watching ? user?.uuid : undefined });
  };

  return (
    <styles.WatchingFilterContainer>
      <Button
        appearance="subtle"
        isSelected={Boolean(watching)}
        onClick={handleFilterChange}
      >
        <FormattedMessage {...i18n.watchingButtonText} />
      </Button>
    </styles.WatchingFilterContainer>
  );
};

export default WatchingFilter;
